import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { AircraftDetailView } from '@/components/AircraftDetailView'

const aircraftDetailSearchSchema = z.object({
  tab: z.enum(['details', 'facilities']).optional().default('details'),
})

export const Route = createFileRoute('/_auth/operations/aircraft/$aircraftId')({
  component: RouteComponent,
  validateSearch: aircraftDetailSearchSchema,
})

function RouteComponent() {
  const { aircraftId } = Route.useParams()
  const { tab } = Route.useSearch()

  return <AircraftDetailView aircraftId={aircraftId} initialTab={tab} />
}
